import React from 'react';
import api from 'api/whatWeOffer';
import rootActions from 'redux/rootActions';
import { FlexContainer } from 'components/common/FlexContainer';
import { ForYou } from 'types/forYou';
import { ForYouIntro } from 'components/forYou/ForYouIntro';
import { ForYouIntroWrapper } from 'components/forYou/ForYouIntroWrapper';
import { GalleryIntro } from 'components/common/GalleryIntro';
import { GetInitialProps } from 'types/getInitialProps';
import { ImagePayoff } from 'components/common/ImagePayoff';
import { ImageSectionIntro } from 'components/common/ImageSectionIntro';
import { Layout } from 'components/common/Layout';
import { MetaTags } from 'components/meta/MetaTags';
import { PageSectionIntro } from 'components/page/PageSectionIntro';
import { Section } from 'components/common/Section';
import { TransparentContainer } from 'components/common/TransparentContainer';
import { connect } from 'react-redux';

interface Props {
    data: ForYou;
    pathName: string;
}

const WhatWeOffer = (props: Props): JSX.Element => {
    const { data, pathName } = props;

    return (
        <Layout pathName={pathName}>
            <MetaTags
                title="Werken bij Developers.nl | Wat bieden wij jou"
                image="/favicons/logo_180.png"
                description="Samen helpen we jou verder. Kom snel te weten wat Developers.nl jou nog meer te bieden heeft!"
                keywords="developer, developers, frontend, php, python, java, learn, code, share"
            />
            <ForYouIntroWrapper>
                <ForYouIntro title={data.firstBlockTitle} description={data.firstBlockText} />
            </ForYouIntroWrapper>
            <Section hasWhiteSpace>
                <FlexContainer>
                    <TransparentContainer>
                        <PageSectionIntro title={data.secondBlockTitle} description={data.secondBlockText} />
                    </TransparentContainer>
                </FlexContainer>
            </Section>
            <Section isEven hasWhiteSpace>
                <FlexContainer>
                    <TransparentContainer>
                        <GalleryIntro
                            title={data.thirdBlockTitle}
                            description={data.thirdBlockText}
                            imageGallery={data.thirdBlockImageCollection.images}
                        />
                    </TransparentContainer>
                </FlexContainer>
            </Section>
            <Section isEven>
                <ImagePayoff
                    title={data.fourthBlockTitle}
                    description={data.fourthBlockText}
                    image={data.fourthBlockThumbnail}
                />
            </Section>
            <Section isEven>
                <ImageSectionIntro
                    title={data.fifthBlockTitle}
                    description={data.fifthBlockText}
                    image={data.fifthBlockThumbnail}
                    readMore={data.readMore}
                />
            </Section>
        </Layout>
    );
};

WhatWeOffer.getInitialProps = async (ctx: GetInitialProps): Promise<any> => {
    const { store } = ctx;

    if (store.getState().whatWeOffer.data) {
        return {
            pathName: ctx.pathname,
        };
    }

    return api.data().then(
        (payload) => {
            store.dispatch(rootActions.fetchWhatWeOfferSuccess(payload));

            return {
                pathName: ctx.pathname,
            };
        },
        (response) => {
            const error = response.error || {
                message: response,
                code: 404,
            };

            store.dispatch(rootActions.fetchWhatWeOfferError(error));

            return {
                pathName: ctx.pathname,
            };
        },
    );
};

export default connect((state) => {
    return {
        data: state.whatWeOffer.data,
    };
}, rootActions)(WhatWeOffer);
